import { ROLES_GERAR_DOCUMENTO } from '@/views/Documento/constants.ts'

const breadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Gerar Documento',
    to: 'GerarDocumento'
  }
]

export default [
  {
    path: '/documento/gerar',
    name: 'GerarDocumento',
    component: () => import('@/views/Documento/GerarDocumentoPage.vue'),
    meta: { roles: ROLES_GERAR_DOCUMENTO, title: 'Gerar Documento', breadcrumb: breadCrumb }
  }
]
